import is from '@sindresorhus/is';

import type { ParsedUrlTile, UrlTileDefinition } from './types';

const isParsedUrlTile = (tile: ParsedUrlTile | undefined): tile is ParsedUrlTile => is.object(tile);

const parseUrlTileValue = (value: string, definitions: readonly UrlTileDefinition[]): ParsedUrlTile | undefined => {
    for (const definition of definitions) {
        const payload = definition.parseValue(value);

        if (is.undefined(payload)) {
            continue;
        }

        const slotKey = definition.slotKeyForPayload(payload);
        const tileKey = definition.tileKeyForPayload(payload);

        if (is.undefined(slotKey) || is.undefined(tileKey)) {
            return undefined;
        }

        return {
            definition,
            payload,
            slotKey,
            tileKey,
            value,
        };
    }

    return undefined;
};

export const parseUrlTileValues = (
    values: readonly string[],
    definitions: readonly UrlTileDefinition[],
): readonly ParsedUrlTile[] => {
    const slots = new Map<string, ParsedUrlTile>();
    const slotOrder: string[] = [];

    for (const value of values) {
        const tile = parseUrlTileValue(value, definitions);

        if (is.undefined(tile)) {
            continue;
        }

        if (!slots.has(tile.slotKey)) {
            slotOrder.push(tile.slotKey);
        }

        slots.set(tile.slotKey, tile);
    }

    return slotOrder.map((slotKey) => slots.get(slotKey)).filter(isParsedUrlTile);
};
